// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3EMMO","emails":"CreateEditClinics_emails__mKwJK","emailTagLabel":"CreateEditClinics_emailTagLabel__2opjz"};